module.exports = __webpack_public_path__ + "static/media/challenge-art-yorker.957b66a3.png";